import { useNavigate, useParams } from "react-router-dom";
import CenteredMessage from "../components/CenteredMessage";
import { useEffect, useState } from "react";
import ApiService from "../ApiService";
import { getToken } from "../LocalStorage";




const CalificarPage = (props: any) => {
    const {idSave} = useParams();
    const navigate = useNavigate();

    const [saves, setSaves] = useState(null);
    const [producto, setProducto] = useState<any>(null);

    //forms
    const [realizado, setRealizado] = useState(1);
    const [calificacion, setCalificacion] = useState(0);
    const [comentario, setComentario] = useState("");

    console.log("idSave:", idSave);

    const getProductoDetails = (idProducto: number) => {
        const tok = getToken() || '';
        (new ApiService()).getOneProducto(tok, idProducto).then((data1:any) => {
            console.log(data1);
            setProducto(data1?.data?.producto);

        }).catch(err => {

        });
    }

    const loadSaves = async () => {
        const tok = getToken() || '';
        (new ApiService()).getSaves(tok).then((data1:any) => {
            console.log(data1);
            setSaves(data1?.data?.saves);
            const sav = data1?.data?.saves?.filter((item:any) => item.id == idSave);
            if (sav ){
                const sav1 = sav[0];
                console.log("sav:", sav1);
                getProductoDetails(sav1.idProducto);
            }
        }).catch(err => {

        });
        
    }

    useEffect(() => {
        loadSaves();
    },[])

    const validar = () => {
        console.log("Realizado:", realizado);
        console.log("calificacion:", calificacion);
        console.log("Comentario:", comentario);

        if (comentario != ''){
            const token = getToken() || '';
            (new ApiService()).calificar(token, realizado, calificacion, comentario, producto?.idUsuario, producto?.id).then((data1:any) => {
                console.log(data1);
                if ( data1.err == 0){
                    alert("Calificacion hecha correctamente, gracias.");
                    navigate("/ndv/saves");
                }else if (data1.err == 3){
                    alert("Ya lo habias calificado");
                }else{
                    alert("Ha ocurrido un error");
                }
            })
        }else{
            alert("Debes ingresar un comentario");
        }
    }

    return      <div className="flexColumn">
                    <h2>Calificar Compra Venta</h2>
                    <div className="flexColumn" style={{alignItems: 'center'}}>
                        <p>{producto?.titulo}</p>
                        <img src={producto?.thumbnail} style={{width: 100, height: 100}} />
                    </div>
                    <fieldset>
                        <legend>¿Se realizo la operacion?</legend>
                        <select value={realizado} onChange={(e) => {
                            setRealizado(parseInt(e.target.value));
                        }}>
                            <option value="1">Si</option>
                            <option value="0">No</option>
                        </select>
                    </fieldset>
                    
                    <fieldset>
                        <legend>¿Como calificaria la operacion?</legend>
                        <select value={calificacion}
                            onChange={(e) => {
                                setCalificacion(parseInt(e.target.value));
                            }}
                        >
                            <option value="1">Buena</option>
                            <option value="0">Regular</option>
                            <option value="-1">Mala</option>
                        </select>
                    </fieldset>
                    <fieldset>
                        <legend>Algun Comentario sobre el vendedor o comprador</legend>
                        <textarea style={{width: '100%', height: 50,}}
                            value={comentario}
                            onChange={(e) => {
                                setComentario(e.target.value);
                            }}
                        ></textarea>
                    </fieldset>
                    <button className="btnNormal" onClick={() => {
                        validar();
                    }}>Guardar Calificacion</button>

                </div>
}

export default CalificarPage;